import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\GetDocumentDossierByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentDossierByIdController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}'
*/
const GetDocumentDossierByIdController = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentDossierByIdController.url(args, options),
    method: 'get',
})

GetDocumentDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/{type}/{document_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\GetDocumentDossierByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentDossierByIdController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}'
*/
GetDocumentDossierByIdController.url = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            type: args[1],
            document_id: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        type: args.type,
        document_id: args.document_id,
    }

    return GetDocumentDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document_id}', parsedArgs.document_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetDocumentDossierByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentDossierByIdController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}'
*/
GetDocumentDossierByIdController.get = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\GetDocumentDossierByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentDossierByIdController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}'
*/
GetDocumentDossierByIdController.head = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDocumentDossierByIdController.url(args, options),
    method: 'head',
})

export default GetDocumentDossierByIdController